import React from 'react';

const Tomorrow = () => {
  return (
    <>
      <div className="flex flex-col rounded-md bg-gray-300 w-full my-2">
        <ul className="text-sm">
          <li className="flex px-2 py-3">
            <p className="w-2/12 text-center font-semibold">Pagi</p>
            <p className="w-4/12 text-center">08.00-09.00 </p>
            <p className="w-4/12 text-center font-semibold">Gratis</p>
            <label className="w-2/12 inline-flex items-center text-center justify-center">
              <input
                type="radio"
                className="form-radio form-radio-orange"
                name="accountType"
                value="personal"
              />
            </label>
          </li>
          <li className="flex px-2 py-3">
            <p className="w-2/12 text-center"></p>
            <p className="w-4/12 text-center">10.00-11.00 </p>
            <p className="w-4/12 text-center">Rp 10.000</p>
            <label className="w-2/12 inline-flex items-center text-center justify-center">
              <input
                type="radio"
                className="form-radio form-radio-orange"
                name="accountType"
                value="personal"
              />
            </label>
          </li>
          <li className="flex px-2 py-3">
            <p className="w-2/12 text-center"></p>
            <p className="w-4/12 text-center">12.00-13.00 </p>
            <p className="w-4/12 text-center">Rp 10.000</p>
            <label className="w-2/12 inline-flex items-center text-center justify-center">
              <input
                type="radio"
                className="form-radio form-radio-orange"
                name="accountType"
                value="personal"
              />
            </label>
          </li>
          <li className="flex px-2 py-3">
            <p className="w-2/12 text-center"></p>
            <p className="w-4/12 text-center">13.00-14.00 </p>
            <p className="w-4/12 text-center">Rp 10.000</p>
            <label className="w-2/12 inline-flex items-center text-center justify-center">
              <input
                type="radio"
                className="form-radio form-radio-orange"
                name="accountType"
                value="personal"
              />
            </label>
          </li>
        </ul>
      </div>
      <div className="flex flex-col rounded-md bg-gray-300 w-full my-2">
        <ul className="text-sm">
          <li className="flex px-2 py-3">
            <p className="w-2/12 text-center font-semibold">Malam</p>
            <p className="w-4/12 text-center">19.00-20.00 </p>
            <p className="w-4/12 text-center font-semibold">Gratis</p>
            <label className="w-2/12 inline-flex items-center text-center justify-center">
              <input
                type="radio"
                className="form-radio form-radio-orange"
                name="accountType"
                value="personal"
              />
            </label>
          </li>
          <li className="flex px-2 py-3">
            <p className="w-2/12 text-center"></p>
            <p className="w-4/12 text-center">20.00-21.00 </p>
            <p className="w-4/12 text-center font-semibold">Penuh</p>
            <label className="w-2/12 inline-flex items-center text-center justify-center">
              <input
                type="radio"
                className="form-radio form-radio-orange"
                name="accountType"
                value="personal"
              />
            </label>
          </li>
          <li className="flex px-2 py-3">
            <p className="w-2/12 text-center"></p>
            <p className="w-4/12 text-center">21.00-2.00 </p>
            <p className="w-4/12 text-center">Rp 10.000</p>
            <label className="w-2/12 inline-flex items-center text-center justify-center">
              <input
                type="radio"
                className="form-radio form-radio-orange"
                name="accountType"
                value="personal"
              />
            </label>
          </li>
        </ul>
      </div>
    </>
  );
};

export default Tomorrow;
